<p-dialog [(visible)]="webhookSelected" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '75vw' }">
	<ng-template pTemplate="header">
		<div class="w-100">
			<div class="d-flex">
				<fa-icon [icon]="['far', 'anchor-circle-check']" class="me-4" size="2x"></fa-icon>
				<div class="display-8 ms-1 my-auto">Webhook Setup</div>
			</div>
			<p-divider></p-divider>
		</div>
	</ng-template>
	<div class="p-grid">
		<div class="p-col-12 p-md-3">
			<span class="p-float-label mt-4">
				<p-dropdown
					#integratorSelect
					[options]="integratorList"
					optionLabel="name"
					optionValue="licenses[0]?.key"
					name="integratorSelect"
					[(ngModel)]="webhookSelected.LicenseKey"
					[style]="{ width: '100%' }"
					appendTo="body"
					[autoDisplayFirst]="false"
					[virtualScroll]="true"
					virtualScrollItemSize="30"
					filter="true"
					(filterBy)="app.keys(integratorList)"
				></p-dropdown>
				<label for="integratorSelect">Integrator</label>
			</span>
		</div>
		<div class="p-col-12 p-md-3">code</div>
	</div>

	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideAdd]="true"
			[hideCancel]=""
			[hideDelete]=""
			[hideSave]=""
			(onCancelChange)="webhookSelected = undefined"
			(onDeleteChange)="webhookDeleteChange.emit(webhookSelected)"
			(onSaveChange)="save()"
			[cancelDisabled]=""
			[deleteDisabled]=""
			[saveDisabled]=""
		></app-record-control-footer>
	</ng-template>
</p-dialog>
